export const CLIENT_ASSESSMENT_DURATION_OPTIONS = [
  {
    value: 900,
    label: '0:15 hr',
  },
  {
    value: 1800,
    label: '0:30 hr',
  },
  {
    value: 2700,
    label: '0:45 hr',
  },
  {
    value: 3600,
    label: '1:00 hr',
  },
  {
    value: 4500,
    label: '1:15 hr',
  },
  {
    value: 5400,
    label: '1:30 hr',
  },
  {
    value: 6300,
    label: '1:45 hr',
  },
  {
    value: 7200,
    label: '2:00 hr',
  },
];

export const ASSESSMENT_NOTE_MIN_LENGTH = 120;
